<template>
	<el-select v-model="model[data.fieldId]"
			   :multiple="data.multiple"
			   :placeholder="data.placeholder"
			   style="width: 100%"
			   :disabled="disabled"
			   @change="selectChange">
		<el-option v-for="(i, index) in selectOptions"
				   :key="'selectOptions' + index"
				   :label="i.label"
				   :value="i.value">
		</el-option>
	</el-select>
</template>

<script>
import RemoteMixin from '../../utils/remote-mixin'
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpSelect',
	mixins: [RemoteMixin],
	inject: [ 'customFormOptions' ],
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	computed: {
		disabled() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'disabled')) {
				return this.customFormOptions[this.data.fieldId].disabled(this.model[this.data.fieldId])
			} else {
				return false
			}
		},

		selectOptions() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'options')) {
				if (this.customFormOptions[this.data.fieldId].options.length > 0 && this.model[this.data.fieldId] === '') {
					this.model[this.data.fieldId] = this.customFormOptions[this.data.fieldId].options[0].value
				}
				return this.customFormOptions[this.data.fieldId].options
			} else {
				return []
			}
		}
	},
	methods: {
		selectChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	}
}
</script>